"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiveActivityEvent = void 0;
var LiveActivityEvent;
(function (LiveActivityEvent) {
    LiveActivityEvent["START"] = "START";
    LiveActivityEvent["UPDATE"] = "UPDATE";
    LiveActivityEvent["END"] = "END";
})(LiveActivityEvent = exports.LiveActivityEvent || (exports.LiveActivityEvent = {}));
(function (LiveActivityEvent) {
    function getAllEvents() {
        var events = Object.getOwnPropertyNames(LiveActivityEvent)
            .filter(function (key) { return typeof LiveActivityEvent[key] === 'string'; })
            .map(function (key) { return LiveActivityEvent[key]; });
        events.sort();
        return events;
    }
    LiveActivityEvent.getAllEvents = getAllEvents;
    function fromString(str) {
        var value = str === null || str === void 0 ? void 0 : str.trim().toUpperCase();
        switch (value) {
            case LiveActivityEvent.UPDATE:
                return LiveActivityEvent.UPDATE;
            case LiveActivityEvent.END:
                return LiveActivityEvent.END;
            case LiveActivityEvent.START:
                return LiveActivityEvent.START;
            default:
                return;
        }
    }
    LiveActivityEvent.fromString = fromString;
})(LiveActivityEvent = exports.LiveActivityEvent || (exports.LiveActivityEvent = {}));
//# sourceMappingURL=live-activity-event.js.map